import config from '../config';

class API {
  // eslint-disable-next-line class-methods-use-this
  buildUrl(endpoint, channel) {
    if (!config[channel]) {
      throw new Error('No valid channel was given');
    }

    const endpoints = {
      nowOnAir: config[channel].tracksApiUrl,
      currentBroadcast: config[channel].broadcastsApiUrl
    };

    return endpoints[endpoint];
  }

  get(endpoint, channel) {
    const apiUrl = this.buildUrl(endpoint, channel);

    return fetch(apiUrl) // eslint-disable-line
      .then(response => response.json())
      .then(
        data => {
          if (!data.data) return data;
          return data.data[0];
        },
        error => {
          throw new Error(error);
        }
      );
  }
}

export default API;
